import { HTTP_URL } from "../config/backend";
import { useState, useEffect } from "react";
import axios from "axios";
import { Bug, X, ChevronUp } from "lucide-react";

const API = HTTP_URL;

export default function BugReport() {
  const [open,    setOpen]    = useState(false);
  const [text,    setText]    = useState("");
  const [email,   setEmail]   = useState("");
  const [phone,   setPhone]   = useState("");
  const [sending, setSending] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState("");
  const [hidden,  setHidden]  = useState(false);

  useEffect(() => {
    const hide = () => { setHidden(true);  setOpen(false); };
    const show = () => { setHidden(false); };
    window.addEventListener("bugreport-hide", hide);
    window.addEventListener("bugreport-show", show);
    return () => {
      window.removeEventListener("bugreport-hide", hide);
      window.removeEventListener("bugreport-show", show);
    };
  }, []);

  if (hidden) return null;

  const send = async () => {
    if (!text.trim())  { setError("Опиши проблему."); return; }
    if (!email.trim()) { setError("Укажи email — мы напишем когда исправим."); return; }
    setSending(true); setError("");
    try {
      await axios.post(`${API}/api/bug-report`, {
        description: text.trim(),
        email:       email.trim(),
        phone:       phone.trim(),
        page:        window.location.pathname,
        user_agent:  navigator.userAgent,
      });
      setSent(true);
      setTimeout(() => { setSent(false); setOpen(false); setText(""); setEmail(""); setPhone(""); }, 3000);
    } catch {
      setError("Не удалось отправить. Попробуй позже.");
    } finally {
      setSending(false);
    }
  };

  const inputStyle = {
    width: "100%", boxSizing: "border-box",
    background: "#0d0820", border: "2px solid #ffffff22",
    borderRadius: "0.6rem", color: "#fff", padding: "0.6rem 0.75rem",
    fontFamily: "'Nunito', sans-serif", fontSize: "0.85rem", outline: "none",
  };

  return (
    <div style={{
      position: "fixed", bottom: "1rem", right: "1rem",
      zIndex: 999, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.5rem",
    }}>
      {open && (
        <div style={{
          background: "#16103a", border: "2.5px solid #ff3cac",
          borderRadius: "1.25rem", padding: "1.25rem",
          width: "300px", boxShadow: "0 8px 32px #ff3cac33",
          animation: "slideUp 0.2s ease",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
            <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1rem", color: "#ff3cac", margin: 0 }}>
              🐛 Нашли проблему?
            </p>
            <button onClick={() => setOpen(false)} style={{ background: "none", border: "none", color: "#555", cursor: "pointer", padding: "0.2rem" }}>
              <X style={{ width: "1rem", height: "1rem" }} />
            </button>
          </div>

          {sent ? (
            <div style={{ textAlign: "center", padding: "0.5rem 0" }}>
              <p style={{ fontFamily: "'Fredoka One', sans-serif", color: "#3dffa0", fontSize: "1rem" }}>
                ✅ Спасибо! Разберёмся.
              </p>
              <p style={{ fontFamily: "'Nunito', sans-serif", color: "#666", fontSize: "0.8rem", marginTop: "0.25rem" }}>
                Если проблема реальная — пришлём промокод 🎁
              </p>
            </div>
          ) : (
            <>
              <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.8rem", color: "#888", marginBottom: "0.75rem", lineHeight: 1.5 }}>
                Опишите что пошло не так — мы обязательно исправим.
                За реальный баг дарим промокод! 🎁
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                <textarea
                  value={text}
                  onChange={e => { setText(e.target.value); setError(""); }}
                  placeholder="Что произошло? Какая игра? Какой экран?"
                  rows={3}
                  style={{ ...inputStyle, resize: "none" }}
                />
                <div>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Email *"
                    required
                    style={{
                      ...inputStyle,
                      borderColor: error && !email.trim() ? "#ff3355" : "#ffffff22",
                    }}
                  />
                  <p style={{ fontFamily: "'Nunito', sans-serif", color: "#555", fontSize: "0.7rem", margin: "0.15rem 0 0 0.25rem" }}>
                    Обязательно — напишем когда исправим
                  </p>
                </div>
                <input
                  type="tel"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  placeholder="Телефон (необязательно)"
                  style={inputStyle}
                />
                {error && (
                  <p style={{ fontFamily: "'Nunito', sans-serif", color: "#ff3355", fontSize: "0.78rem", margin: 0 }}>
                    {error}
                  </p>
                )}
                <button
                  onClick={send}
                  disabled={sending || !text.trim()}
                  style={{
                    background: "#ff3cac", color: "#fff",
                    border: "2px solid #000", borderRadius: "0.6rem",
                    boxShadow: "2px 2px 0 #000", padding: "0.6rem",
                    fontFamily: "'Fredoka One', sans-serif", fontSize: "0.95rem",
                    cursor: sending || !text.trim() ? "not-allowed" : "pointer",
                    opacity: sending || !text.trim() ? 0.6 : 1,
                  }}
                >
                  {sending ? "Отправка..." : "Отправить 🐛"}
                </button>
              </div>
            </>
          )}
        </div>
      )}

      <button
        onClick={() => setOpen(o => !o)}
        style={{
          background: open ? "#333" : "#ff3cac",
          border: "2.5px solid #000", borderRadius: "9999px",
          boxShadow: "3px 3px 0 #000", padding: "0.6rem 1rem",
          display: "flex", alignItems: "center", gap: "0.4rem",
          fontFamily: "'Fredoka One', sans-serif", fontSize: "0.85rem",
          color: "#fff", cursor: "pointer", transition: "background 0.15s",
        }}
        title="Сообщить о проблеме"
      >
        {open
          ? <><ChevronUp style={{ width: "0.9rem", height: "0.9rem" }} /> Закрыть</>
          : <><Bug style={{ width: "0.9rem", height: "0.9rem" }} /> Помощь</>
        }
      </button>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}